import { parse } from 'hub-http/helpers/params';
import { parseUrl } from 'hub-http/helpers/url';
import Raven from 'raven-js';
import recommendedHubToApiNameMap from 'self-service-api/constants/RecommendedHubToApiNameMap';
import { RECOMMENDED_MARKETING_HUB, RECOMMENDED_SALES_HUB, RECOMMENDED_SERVICE_HUB } from '../constants/RecommendedHubs';
import { fetchDataModelRecommendedHub } from './fetchRecommendedHub';
const recommendationOverride = () => {
  const params = parse(parseUrl(window.location.href).query);
  const hubParam = params.hub ? params.hub.toUpperCase() : null;
  if (!hubParam) return null;
  switch (hubParam) {
    case RECOMMENDED_MARKETING_HUB:
      return RECOMMENDED_MARKETING_HUB;
    case RECOMMENDED_SALES_HUB:
      return RECOMMENDED_SALES_HUB;
    case RECOMMENDED_SERVICE_HUB:
      return RECOMMENDED_SERVICE_HUB;
    default:
      return null;
  }
};
export const getRecommendedApiName = ({
  fallbackApiName,
  earlyRequester,
  hubTypes
}) => {
  const hubOverride = recommendationOverride();
  if (hubOverride) {
    const recommendedApiNameData = {
      recommendedHub: hubOverride,
      apiName: recommendedHubToApiNameMap[hubOverride],
      correlationId: null
    };
    return Promise.resolve(recommendedApiNameData);
  } else {
    return fetchDataModelRecommendedHub(earlyRequester, hubTypes).then(({
      hubType,
      correlationId
    }) => {
      const recommendedApiNameData = {
        recommendedHub: hubType,
        apiName: recommendedHubToApiNameMap[hubType],
        correlationId
      };
      return recommendedApiNameData;
    }).catch(error => {
      Raven.captureException(new Error('Failed to fetch recommended hub from ML model api'), {
        extra: {
          error
        }
      });
      const recommendedApiNameData = {
        recommendedHub: RECOMMENDED_MARKETING_HUB,
        apiName: fallbackApiName,
        correlationId: null
      };
      return recommendedApiNameData;
    });
  }
};
export const getDataModelRecommendedApiName = (earlyRequester, fallbackApiName, hubTypes) => {
  return getRecommendedApiName({
    fallbackApiName,
    earlyRequester,
    hubTypes
  });
};